import script from "./stlm-mn-mng.vue?vue&type=script&setup=true&lang=js"
export * from "./stlm-mn-mng.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__